export const plaidConnectionStates = {
  INIT: 'INIT',
  LOADING: 'LOADING',
  CONNECTED: 'CONNECTED',
  CANCELLED: 'CANCELLED',
  ERROR: 'ERROR',
};
